import { signInWithCustomToken } from 'firebase/auth'

import { auth } from '@/app/config/firebase'
import { getHttpStatusName } from '@/shared/utils/httpStatus'

const API_BASE_URL = import.meta.env.DEV
  ? '/eb-hub-service/eb-hub/v1'
  : 'https://eb-hub-service.enter.de/eb-hub/v1'

interface LoginResponse {
  data: {
    auth_token: string
  }
}

/**
 * Login with token from session storage
 * This function will make an API call to get a Firebase custom token
 * and then sign in the user with that token
 *
 * @param token - Authentication token (ID token) from session storage
 * @returns Promise<void>
 */
export const loginWithToken = async (token: string): Promise<void> => {
  try {
    // Call the backend API with the ID token in the header
    const response = await fetch(`${API_BASE_URL}/token`, {
      method: 'GET',
      headers: {
        'x-id-token': token,
      },
    })

    // Parse the response body
    const responseData: LoginResponse = await response.json()

    // Check if the request was successful
    if (!response.ok) {
      const statusName = getHttpStatusName(response.status)
      throw new Error(
        `Anmeldung fehlgeschlagen: ${statusName}. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.`
      )
    }

    // Extract the auth token from the response
    const authToken = responseData?.data?.auth_token
    if (!authToken) {
      throw new Error(
        'Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.'
      )
    }

    // Sign in with the custom token
    await signInWithCustomToken(auth, authToken)
  } catch (error) {
    console.error('Login failed:', error)
    throw error
  }
}
